export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.769 6.278a.75.75 0 0 0-1.061-.007l-5.192 5.117V9.227a.75.75 0 1 0-1.5 0v5.968c0 .415.335.75.75.75h6.015a.75.75 0 1 0 0-1.5H10.58l5.182-5.106a.75.75 0 0 0 .008-1.06Z"/>
</svg>`;
